var commonjsGlobal =
  typeof globalThis !== "undefined"
    ? globalThis
    : typeof window !== "undefined"
    ? window
    : typeof global !== "undefined"
    ? global
    : typeof self !== "undefined"
    ? self
    : {};

function createCommonjsModule(fn, basedir, module) {
  return (
    (module = {
      path: basedir,
      exports: {},
      require: function (path, base) {
        return commonjsRequire(path, base === undefined || base === null ? module.path : base);
      },
    }),
    fn(module, module.exports),
    module.exports
  );
}

function commonjsRequire() {
  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == "object" && globalThis) ||
  check(typeof window == "object" && window) ||
  check(typeof self == "object" && self) ||
  check(typeof commonjsGlobal == "object" && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func
  Function("return this")();

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var descriptors = !fails(function () {
  return (
    Object.defineProperty({}, 1, {
      get: function () {
        return 7;
      },
    })[1] != 7
  );
});

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
var f = NASHORN_BUG
  ? function propertyIsEnumerable(V) {
      var descriptor = getOwnPropertyDescriptor(this, V);
      return !!descriptor && descriptor.enumerable;
    }
  : nativePropertyIsEnumerable;

var objectPropertyIsEnumerable = {
  f: f,
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value,
  };
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var split = "".split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object("z").propertyIsEnumerable(0);
})
  ? function (it) {
      return classofRaw(it) == "String" ? split.call(it, "") : Object(it);
    }
  : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings

var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

var isObject = function (it) {
  return typeof it === "object" ? it !== null : typeof it === "function";
};

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (
    PREFERRED_STRING &&
    typeof (fn = input.toString) == "function" &&
    !isObject((val = fn.call(input)))
  )
    return val;
  if (typeof (fn = input.valueOf) == "function" && !isObject((val = fn.call(input)))) return val;
  if (
    !PREFERRED_STRING &&
    typeof (fn = input.toString) == "function" &&
    !isObject((val = fn.call(input)))
  )
    return val;
  throw TypeError("Can't convert object to primitive value");
};

var hasOwnProperty = {}.hasOwnProperty;

var has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine =
  !descriptors &&
  !fails(function () {
    return (
      Object.defineProperty(documentCreateElement("div"), "a", {
        get: function () {
          return 7;
        },
      }).a != 7
    );
  });

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
var f$1 = descriptors
  ? nativeGetOwnPropertyDescriptor
  : function getOwnPropertyDescriptor(O, P) {
      O = toIndexedObject(O);
      P = toPrimitive(P, true);
      if (ie8DomDefine)
        try {
          return nativeGetOwnPropertyDescriptor(O, P);
        } catch (error) {
          /* empty */
        }
      if (has(O, P))
        return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
    };

var objectGetOwnPropertyDescriptor = {
  f: f$1,
};

var anObject = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + " is not an object");
  }
  return it;
};

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
var f$2 = descriptors
  ? nativeDefineProperty
  : function defineProperty(O, P, Attributes) {
      anObject(O);
      P = toPrimitive(P, true);
      anObject(Attributes);
      if (ie8DomDefine)
        try {
          return nativeDefineProperty(O, P, Attributes);
        } catch (error) {
          /* empty */
        }
      if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported");
      if ("value" in Attributes) O[P] = Attributes.value;
      return O;
    };

var objectDefineProperty = {
  f: f$2,
};

var createNonEnumerableProperty = descriptors
  ? function (object, key, value) {
      return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
    }
  : function (object, key, value) {
      object[key] = value;
      return object;
    };

var setGlobal = function (key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  }
  return value;
};

var SHARED = "__core-js_shared__";
var store = global_1[SHARED] || setGlobal(SHARED, {});

var sharedStore = store;

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof sharedStore.inspectSource != "function") {
  sharedStore.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap = global_1.WeakMap;

var nativeWeakMap = typeof WeakMap === "function" && /native code/.test(inspectSource(WeakMap));

var shared = createCommonjsModule(function (module) {
  (module.exports = function (key, value) {
    return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
  })("versions", []).push({
    version: "3.6.5",
    mode: "global",
    copyright: "© 2020 Denis Pushkarev (zloirock.ru)",
  });
});

var id = 0;
var postfix = Math.random();

var uid = function (key) {
  return "Symbol(" + String(key === undefined ? "" : key) + ")_" + (++id + postfix).toString(36);
};

var keys = shared("keys");

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var WeakMap$1 = global_1.WeakMap;
var set, get, has$1;

var enforce = function (it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError("Incompatible receiver, " + TYPE + " required");
    }
    return state;
  };
};

if (nativeWeakMap) {
  var store$1 = new WeakMap$1();
  var wmget = store$1.get;
  var wmhas = store$1.has;
  var wmset = store$1.set;
  set = function (it, metadata) {
    wmset.call(store$1, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store$1, it) || {};
  };
  has$1 = function (it) {
    return wmhas.call(store$1, it);
  };
} else {
  var STATE = sharedKey("state");
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return has(it, STATE) ? it[STATE] : {};
  };
  has$1 = function (it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor,
};

var redefine = createCommonjsModule(function (module) {
  var getInternalState = internalState.get;
  var enforceInternalState = internalState.enforce;
  var TEMPLATE = String(String).split("String");

  (module.exports = function (O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    if (typeof value == "function") {
      if (typeof key == "string" && !has(value, "name"))
        createNonEnumerableProperty(value, "name", key);
      enforceInternalState(value).source = TEMPLATE.join(typeof key == "string" ? key : "");
    }
    if (O === global_1) {
      if (simple) O[key] = value;
      else setGlobal(key, value);
      return;
    } else if (!unsafe) {
      delete O[key];
    } else if (!noTargetGet && O[key]) {
      simple = true;
    }
    if (simple) O[key] = value;
    else createNonEnumerableProperty(O, key, value);
    // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
  })(Function.prototype, "toString", function toString() {
    return (typeof this == "function" && getInternalState(this).source) || inspectSource(this);
  });
});

var path = global_1;

var aFunction = function (variable) {
  return typeof variable == "function" ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2
    ? aFunction(path[namespace]) || aFunction(global_1[namespace])
    : (path[namespace] && path[namespace][method]) ||
        (global_1[namespace] && global_1[namespace][method]);
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
var toInteger = function (argument) {
  return isNaN((argument = +argument)) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1fffffffffffff) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el)
      while (length > index) {
        value = O[index++];
        // eslint-disable-next-line no-self-compare
        if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
      }
    else
      for (; length > index; index++) {
        if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
      }
    return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false),
};

var indexOf = arrayIncludes.indexOf;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i)
    if (has(O, (key = names[i++]))) {
      ~indexOf(result, key) || result.push(key);
    }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf",
];

var hiddenKeys$1 = enumBugKeys.concat("length", "prototype");

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
var f$3 =
  Object.getOwnPropertyNames ||
  function getOwnPropertyNames(O) {
    return objectKeysInternal(O, hiddenKeys$1);
  };

var objectGetOwnPropertyNames = {
  f: f$3,
};

var f$4 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
  f: f$4,
};

// all object keys, includes non-enumerable and symbols
var ownKeys =
  getBuiltIn("Reflect", "ownKeys") ||
  function ownKeys(it) {
    var keys = objectGetOwnPropertyNames.f(anObject(it));
    var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
  };

var copyConstructorProperties = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL
    ? true
    : value == NATIVE
    ? false
    : typeof detection == "function"
    ? fails(detection)
    : !!detection;
};

var normalize = (isForced.normalize = function (string) {
  return String(string).replace(replacement, ".").toLowerCase();
});

var data = (isForced.data = {});
var NATIVE = (isForced.NATIVE = "N");
var POLYFILL = (isForced.POLYFILL = "P");

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target)
    for (key in source) {
      sourceProperty = source[key];
      if (options.noTargetGet) {
        descriptor = getOwnPropertyDescriptor$1(target, key);
        targetProperty = descriptor && descriptor.value;
      } else targetProperty = target[key];
      FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
      // contained in target
      if (!FORCED && targetProperty !== undefined) {
        if (typeof sourceProperty === typeof targetProperty) continue;
        copyConstructorProperties(sourceProperty, targetProperty);
      }
      // add a flag to not completely full polyfills
      if (options.sham || (targetProperty && targetProperty.sham)) {
        createNonEnumerableProperty(sourceProperty, "sham", true);
      }
      // extend global
      redefine(target, key, sourceProperty, options);
    }
};

var aFunction$1 = function (it) {
  if (typeof it != "function") {
    throw TypeError(String(it) + " is not a function");
  }
  return it;
};

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0:
      return function () {
        return fn.call(that);
      };
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
var toObject = function (argument) {
  return Object(requireObjectCoercible(argument));
};

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
var isArray =
  Array.isArray ||
  function isArray(arg) {
    return classofRaw(arg) == "Array";
  };

var nativeSymbol =
  !!Object.getOwnPropertySymbols &&
  !fails(function () {
    // Chrome 38 Symbol has incorrect toString conversion
    // eslint-disable-next-line no-undef
    return !String(Symbol());
  });

var useSymbolAsUid =
  nativeSymbol &&
  // eslint-disable-next-line no-undef
  !Symbol.sham &&
  // eslint-disable-next-line no-undef
  typeof Symbol.iterator == "symbol";

var WellKnownSymbolsStore = shared("wks");
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : (Symbol$1 && Symbol$1.withoutSetter) || uid;

var wellKnownSymbol = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (nativeSymbol && has(Symbol$1, name)) WellKnownSymbolsStore[name] = Symbol$1[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol("Symbol." + name);
  }
  return WellKnownSymbolsStore[name];
};

var SPECIES = wellKnownSymbol("species");

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == "function" && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }
  return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (; length > index; index++)
      if (NO_HOLES || index in self) {
        value = self[index];
        result = boundFunction(value, index, O);
        if (TYPE) {
          if (IS_MAP) target[index] = result;
          // map
          else if (result)
            switch (TYPE) {
              case 3:
                return true; // some
              case 5:
                return value; // find
              case 6:
                return index; // findIndex
              case 2:
                push.call(target, value); // filter
            }
          else if (IS_EVERY) return false; // every
        }
      }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
};

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
var objectKeys =
  Object.keys ||
  function keys(O) {
    return objectKeysInternal(O, enumBugKeys);
  };

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
var objectDefineProperties = descriptors
  ? Object.defineProperties
  : function defineProperties(O, Properties) {
      anObject(O);
      var keys = objectKeys(Properties);
      var length = keys.length;
      var index = 0;
      var key;
      while (length > index) objectDefineProperty.f(O, (key = keys[index++]), Properties[key]);
      return O;
    };

var html = getBuiltIn("document", "documentElement");

var GT = ">";
var LT = "<";
var PROTOTYPE = "prototype";
var SCRIPT = "script";
var IE_PROTO = sharedKey("IE_PROTO");

var EmptyConstructor = function () {
  /* empty */
};

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(""));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement("iframe");
  var JS = "java" + SCRIPT + ":";
  var iframeDocument;
  iframe.style.display = "none";
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag("document.F=Object"));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject("htmlfile");
  } catch (error) {
    /* ignore */
  }
  NullProtoObject = activeXDocument
    ? NullProtoObjectViaActiveX(activeXDocument)
    : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
var objectCreate =
  Object.create ||
  function create(O, Properties) {
    var result;
    if (O !== null) {
      EmptyConstructor[PROTOTYPE] = anObject(O);
      result = new EmptyConstructor();
      EmptyConstructor[PROTOTYPE] = null;
      // add "__proto__" for Object.getPrototypeOf polyfill
      result[IE_PROTO] = O;
    } else result = NullProtoObject();
    return Properties === undefined ? result : objectDefineProperties(result, Properties);
  };

var UNSCOPABLES = wellKnownSymbol("unscopables");
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  objectDefineProperty.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null),
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) {
  throw it;
};

var arrayMethodUsesToLength = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, "ACCESSORS") ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return (cache[METHOD_NAME] =
    !!method &&
    !fails(function () {
      if (ACCESSORS && !descriptors) return true;
      var O = { length: -1 };

      if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
      else O[1] = 1;

      method.call(O, argument0, argument1);
    }));
};

var $find = arrayIteration.find;

var FIND = "find";
var SKIPS_HOLES = true;

var USES_TO_LENGTH = arrayMethodUsesToLength(FIND);

// Shouldn't skip holes
if (FIND in [])
  Array(1)[FIND](function () {
    SKIPS_HOLES = false;
  });

// `Array.prototype.find` method
// https://tc39.github.io/ecma262/#sec-array.prototype.find
_export(
  { target: "Array", proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH },
  {
    find: function find(callbackfn /* , that = undefined */) {
      return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
  }
);

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);

var iterators = {};

var correctPrototypeGetter = !fails(function () {
  function F() {
    /* empty */
  }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$1 = sharedKey("IE_PROTO");
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
var objectGetPrototypeOf = correctPrototypeGetter
  ? Object.getPrototypeOf
  : function (O) {
      O = toObject(O);
      if (has(O, IE_PROTO$1)) return O[IE_PROTO$1];
      if (typeof O.constructor == "function" && O instanceof O.constructor) {
        return O.constructor.prototype;
      }
      return O instanceof Object ? ObjectPrototype : null;
    };

var ITERATOR = wellKnownSymbol("iterator");
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () {
  return this;
};

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!("next" in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype)
      IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS,
};

var defineProperty$1 = objectDefineProperty.f;

var TO_STRING_TAG = wellKnownSymbol("toStringTag");

var setToStringTag = function (it, TAG, STATIC) {
  if (it && !has((it = STATIC ? it : it.prototype), TO_STRING_TAG)) {
    defineProperty$1(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;

var returnThis$1 = function () {
  return this;
};

var createIteratorConstructor = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + " Iterator";
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, {
    next: createPropertyDescriptor(1, next),
  });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  iterators[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var aPossiblePrototype = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + " as a prototype");
  }
  return it;
};

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var objectSetPrototypeOf =
  Object.setPrototypeOf ||
  ("__proto__" in {}
    ? (function () {
        var CORRECT_SETTER = false;
        var test = {};
        var setter;
        try {
          setter = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set;
          setter.call(test, []);
          CORRECT_SETTER = test instanceof Array;
        } catch (error) {
          /* empty */
        }
        return function setPrototypeOf(O, proto) {
          anObject(O);
          aPossiblePrototype(proto);
          if (CORRECT_SETTER) setter.call(O, proto);
          else O.__proto__ = proto;
          return O;
        };
      })()
    : undefined);

var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol("iterator");
var KEYS = "keys";
var VALUES = "values";
var ENTRIES = "entries";

var returnThis$2 = function () {
  return this;
};

var defineIterator = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS:
        return function keys() {
          return new IteratorConstructor(this, KIND);
        };
      case VALUES:
        return function values() {
          return new IteratorConstructor(this, KIND);
        };
      case ENTRIES:
        return function entries() {
          return new IteratorConstructor(this, KIND);
        };
    }
    return function () {
      return new IteratorConstructor(this);
    };
  };

  var TO_STRING_TAG = NAME + " Iterator";
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator =
    IterablePrototype[ITERATOR$1] ||
    IterablePrototype["@@iterator"] ||
    (DEFAULT && IterablePrototype[DEFAULT]);
  var defaultIterator =
    (!BUGGY_SAFARI_ITERATORS$1 && nativeIterator) || getIterationMethod(DEFAULT);
  var anyNativeIterator =
    NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype$2 !== Object.prototype && CurrentIteratorPrototype.next) {
      if (objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$1] != "function") {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR$1, returnThis$2);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() {
      return nativeIterator.call(this);
    };
  }

  // define iterator
  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR$1, defaultIterator);
  }
  iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES),
    };
    if (FORCED)
      for (KEY in methods) {
        if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
          redefine(IterablePrototype, KEY, methods[KEY]);
        }
      }
    else
      _export(
        { target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME },
        methods
      );
  }

  return methods;
};

var ARRAY_ITERATOR = "Array Iterator";
var setInternalState = internalState.set;
var getInternalState = internalState.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(
  Array,
  "Array",
  function (iterated, kind) {
    setInternalState(this, {
      type: ARRAY_ITERATOR,
      target: toIndexedObject(iterated), // target
      index: 0, // next index
      kind: kind, // kind
    });
    // `%ArrayIteratorPrototype%.next` method
    // https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
  },
  function () {
    var state = getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
      state.target = undefined;
      return { value: undefined, done: true };
    }
    if (kind == "keys") return { value: index, done: false };
    if (kind == "values") return { value: target[index], done: false };
    return { value: [index, target[index]], done: false };
  },
  "values"
);

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
iterators.Arguments = iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables("keys");
addToUnscopables("values");
addToUnscopables("entries");

var engineUserAgent = getBuiltIn("navigator", "userAgent") || "";

var process = global_1.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split(".");
  version = match[0] + match[1];
} else if (engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

var SPECIES$1 = wellKnownSymbol("species");

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return (
    engineV8Version >= 51 ||
    !fails(function () {
      var array = [];
      var constructor = (array.constructor = {});
      constructor[SPECIES$1] = function () {
        return { foo: 1 };
      };
      return array[METHOD_NAME](Boolean).foo !== 1;
    })
  );
};

var $map = arrayIteration.map;

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("map");
// FF49- issue
var USES_TO_LENGTH$1 = arrayMethodUsesToLength("map");

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
_export(
  { target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH$1 },
  {
    map: function map(callbackfn /* , thisArg */) {
      return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
  }
);

var propertyIsEnumerable = objectPropertyIsEnumerable.f;

// `Object.{ entries, values }` methods implementation
var createMethod$2 = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!descriptors || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

var objectToArray = {
  // `Object.entries` method
  // https://tc39.github.io/ecma262/#sec-object.entries
  entries: createMethod$2(true),
  // `Object.values` method
  // https://tc39.github.io/ecma262/#sec-object.values
  values: createMethod$2(false),
};

var $entries = objectToArray.entries;

// `Object.entries` method
// https://tc39.github.io/ecma262/#sec-object.entries
_export(
  { target: "Object", stat: true },
  {
    entries: function entries(O) {
      return $entries(O);
    },
  }
);

var TO_STRING_TAG$1 = wellKnownSymbol("toStringTag");
var test = {};

test[TO_STRING_TAG$1] = "z";

var toStringTagSupport = String(test) === "[object z]";

var TO_STRING_TAG$2 = wellKnownSymbol("toStringTag");
// ES3 wrong here
var CORRECT_ARGUMENTS =
  classofRaw(
    (function () {
      return arguments;
    })()
  ) == "Arguments";

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) {
    /* empty */
  }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport
  ? classofRaw
  : function (it) {
      var O, tag, result;
      return it === undefined
        ? "Undefined"
        : it === null
        ? "Null"
        : // @@toStringTag case
        typeof (tag = tryGet((O = Object(it)), TO_STRING_TAG$2)) == "string"
        ? tag
        : // builtinTag case
        CORRECT_ARGUMENTS
        ? classofRaw(O)
        : // ES3 arguments fallback
        (result = classofRaw(O)) == "Object" && typeof O.callee == "function"
        ? "Arguments"
        : result;
    };

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
var objectToString = toStringTagSupport
  ? {}.toString
  : function toString() {
      return "[object " + classof(this) + "]";
    };

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!toStringTagSupport) {
  redefine(Object.prototype, "toString", objectToString, { unsafe: true });
}

var nativePromiseConstructor = global_1.Promise;

var redefineAll = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};

var SPECIES$2 = wellKnownSymbol("species");

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = objectDefineProperty.f;

  if (descriptors && Constructor && !Constructor[SPECIES$2]) {
    defineProperty(Constructor, SPECIES$2, {
      configurable: true,
      get: function () {
        return this;
      },
    });
  }
};

var anInstance = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError("Incorrect " + (name ? name + " " : "") + "invocation");
  }
  return it;
};

var ITERATOR$2 = wellKnownSymbol("iterator");
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype$1[ITERATOR$2] === it);
};

var ITERATOR$3 = wellKnownSymbol("iterator");

var getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$3] || it["@@iterator"] || iterators[classof(it)];
};

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator["return"];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};

var iterate_1 = createCommonjsModule(function (module) {
  var Result = function (stopped, result) {
    this.stopped = stopped;
    this.result = result;
  };

  var iterate = (module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
    var boundFunction = functionBindContext(fn, that, AS_ENTRIES ? 2 : 1);
    var iterator, iterFn, index, length, result, next, step;

    if (IS_ITERATOR) {
      iterator = iterable;
    } else {
      iterFn = getIteratorMethod(iterable);
      if (typeof iterFn != "function") throw TypeError("Target is not iterable");
      // optimisation for array iterators
      if (isArrayIteratorMethod(iterFn)) {
        for (index = 0, length = toLength(iterable.length); length > index; index++) {
          result = AS_ENTRIES
            ? boundFunction(anObject((step = iterable[index]))[0], step[1])
            : boundFunction(iterable[index]);
          if (result && result instanceof Result) return result;
        }
        return new Result(false);
      }
      iterator = iterFn.call(iterable);
    }

    next = iterator.next;
    while (!(step = next.call(iterator)).done) {
      result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
      if (typeof result == "object" && result && result instanceof Result) return result;
    }
    return new Result(false);
  });

  iterate.stop = function (result) {
    return new Result(true, result);
  };
});

var ITERATOR$4 = wellKnownSymbol("iterator");
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    return: function () {
      SAFE_CLOSING = true;
    },
  };
  iteratorWithReturn[ITERATOR$4] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () {
    throw 2;
  });
} catch (error) {
  /* empty */
}

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$4] = function () {
      return {
        next: function () {
          return { done: (ITERATION_SUPPORT = true) };
        },
      };
    };
    exec(object);
  } catch (error) {
    /* empty */
  }
  return ITERATION_SUPPORT;
};

var SPECIES$3 = wellKnownSymbol("species");

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES$3]) == undefined
    ? defaultConstructor
    : aFunction$1(S);
};

var engineIsIos = /(iphone|ipod|ipad).*applewebkit/i.test(engineUserAgent);

var location = global_1.location;
var set$1 = global_1.setImmediate;
var clear = global_1.clearImmediate;
var process$1 = global_1.process;
var MessageChannel = global_1.MessageChannel;
var Dispatch = global_1.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = "onreadystatechange";
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global_1.postMessage(id + "", location.protocol + "//" + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$1 || !clear) {
  set$1 = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == "function" ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (classofRaw(process$1) == "process") {
    defer = function (id) {
      process$1.nextTick(runner(id));
    };
    // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
    // Browsers with MessageChannel, includes WebWorkers
    // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !engineIsIos) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = functionBindContext(port.postMessage, port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global_1.addEventListener &&
    typeof postMessage == "function" &&
    !global_1.importScripts &&
    !fails(post) &&
    location.protocol !== "file:"
  ) {
    defer = post;
    global_1.addEventListener("message", listener, false);
    // IE8-
  } else if (ONREADYSTATECHANGE in documentCreateElement("script")) {
    defer = function (id) {
      html.appendChild(documentCreateElement("script"))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
    // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task = {
  set: set$1,
  clear: clear,
};

var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;

var macrotask = task.set;

var MutationObserver = global_1.MutationObserver || global_1.WebKitMutationObserver;
var process$2 = global_1.process;
var Promise$1 = global_1.Promise;
var IS_NODE = classofRaw(process$2) == "process";
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$2(global_1, "queueMicrotask");
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process$2.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    }
    last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (IS_NODE) {
    notify = function () {
      process$2.nextTick(flush);
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  } else if (MutationObserver && !engineIsIos) {
    toggle = true;
    node = document.createTextNode("");
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
    // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    then = promise.then;
    notify = function () {
      then.call(promise, flush);
    };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global_1, flush);
    };
  }
}

var microtask =
  queueMicrotask ||
  function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    }
    last = task;
  };

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction$1(resolve);
  this.reject = aFunction$1(reject);
};

// 25.4.1.5 NewPromiseCapability(C)
var f$5 = function (C) {
  return new PromiseCapability(C);
};

var newPromiseCapability = {
  f: f$5,
};

var promiseResolve = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var hostReportErrors = function (a, b) {
  var console = global_1.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};

var perform = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var task$1 = task.set;

var SPECIES$4 = wellKnownSymbol("species");
var PROMISE = "Promise";
var getInternalState$1 = internalState.get;
var setInternalState$1 = internalState.set;
var getInternalPromiseState = internalState.getterFor(PROMISE);
var PromiseConstructor = nativePromiseConstructor;
var TypeError$1 = global_1.TypeError;
var document$2 = global_1.document;
var process$3 = global_1.process;
var $fetch = getBuiltIn("fetch");
var newPromiseCapability$1 = newPromiseCapability.f;
var newGenericPromiseCapability = newPromiseCapability$1;
var IS_NODE$1 = classofRaw(process$3) == "process";
var DISPATCH_EVENT = !!(document$2 && document$2.createEvent && global_1.dispatchEvent);
var UNHANDLED_REJECTION = "unhandledrejection";
var REJECTION_HANDLED = "rejectionhandled";
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED = isForced_1(PROMISE, function () {
  var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
  if (!GLOBAL_CORE_JS_PROMISE) {
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (engineV8Version === 66) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    if (!IS_NODE$1 && typeof PromiseRejectionEvent != "function") return true;
  }
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (engineV8Version >= 51 && /native code/.test(PromiseConstructor)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = PromiseConstructor.resolve(1);
  var FakePromise = function (exec) {
    exec(
      function () {
        /* empty */
      },
      function () {
        /* empty */
      }
    );
  };
  var constructor = (promise.constructor = {});
  constructor[SPECIES$4] = FakePromise;
  return !(
    promise.then(function () {
      /* empty */
    }) instanceof FakePromise
  );
});

var INCORRECT_ITERATION =
  FORCED ||
  !checkCorrectnessOfIteration(function (iterable) {
    PromiseConstructor.all(iterable)["catch"](function () {
      /* empty */
    });
  });

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == "function" ? then : false;
};

var notify$1 = function (promise, state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1("Promise-chain cycle"));
          } else if ((then = isThenable(result))) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(promise, state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$2.createEvent("Event");
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global_1.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if ((handler = global_1["on" + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors("Unhandled promise rejection", reason);
};

var onUnhandled = function (promise, state) {
  task$1.call(global_1, function () {
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE$1) {
          process$3.emit("unhandledRejection", value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (promise, state) {
  task$1.call(global_1, function () {
    if (IS_NODE$1) {
      process$3.emit("rejectionHandled", promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, promise, state, unwrap) {
  return function (value) {
    fn(promise, state, value, unwrap);
  };
};

var internalReject = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify$1(promise, state, true);
};

var internalResolve = function (promise, state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(
            value,
            bind(internalResolve, promise, wrapper, state),
            bind(internalReject, promise, wrapper, state)
          );
        } catch (error) {
          internalReject(promise, wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify$1(promise, state, false);
    }
  } catch (error) {
    internalReject(promise, { done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromiseConstructor, PROMISE);
    aFunction$1(executor);
    Internal.call(this);
    var state = getInternalState$1(this);
    try {
      executor(bind(internalResolve, this, state), bind(internalReject, this, state));
    } catch (error) {
      internalReject(this, state, error);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    setInternalState$1(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined,
    });
  };
  Internal.prototype = redefineAll(PromiseConstructor.prototype, {
    // `Promise.prototype.then` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == "function" ? onFulfilled : true;
      reaction.fail = typeof onRejected == "function" && onRejected;
      reaction.domain = IS_NODE$1 ? process$3.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify$1(this, state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
    catch: function (onRejected) {
      return this.then(undefined, onRejected);
    },
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState$1(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, promise, state);
    this.reject = bind(internalReject, promise, state);
  };
  newPromiseCapability.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (typeof nativePromiseConstructor == "function") {
    nativeThen = nativePromiseConstructor.prototype.then;

    // wrap native Promise#then for native async functions
    redefine(
      nativePromiseConstructor.prototype,
      "then",
      function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          nativeThen.call(that, resolve, reject);
        }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
      },
      { unsafe: true }
    );

    // wrap fetch result
    if (typeof $fetch == "function")
      _export(
        { global: true, enumerable: true, forced: true },
        {
          // eslint-disable-next-line no-unused-vars
          fetch: function fetch(input /* , init */) {
            return promiseResolve(PromiseConstructor, $fetch.apply(global_1, arguments));
          },
        }
      );
  }
}

_export(
  { global: true, wrap: true, forced: FORCED },
  {
    Promise: PromiseConstructor,
  }
);

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

PromiseWrapper = getBuiltIn(PROMISE);

// statics
_export(
  { target: PROMISE, stat: true, forced: FORCED },
  {
    // `Promise.reject` method
    // https://tc39.github.io/ecma262/#sec-promise.reject
    reject: function reject(r) {
      var capability = newPromiseCapability$1(this);
      capability.reject.call(undefined, r);
      return capability.promise;
    },
  }
);

_export(
  { target: PROMISE, stat: true, forced: FORCED },
  {
    // `Promise.resolve` method
    // https://tc39.github.io/ecma262/#sec-promise.resolve
    resolve: function resolve(x) {
      return promiseResolve(this, x);
    },
  }
);

_export(
  { target: PROMISE, stat: true, forced: INCORRECT_ITERATION },
  {
    // `Promise.all` method
    // https://tc39.github.io/ecma262/#sec-promise.all
    all: function all(iterable) {
      var C = this;
      var capability = newPromiseCapability$1(C);
      var resolve = capability.resolve;
      var reject = capability.reject;
      var result = perform(function () {
        var $promiseResolve = aFunction$1(C.resolve);
        var values = [];
        var counter = 0;
        var remaining = 1;
        iterate_1(iterable, function (promise) {
          var index = counter++;
          var alreadyCalled = false;
          values.push(undefined);
          remaining++;
          $promiseResolve.call(C, promise).then(function (value) {
            if (alreadyCalled) return;
            alreadyCalled = true;
            values[index] = value;
            --remaining || resolve(values);
          }, reject);
        });
        --remaining || resolve(values);
      });
      if (result.error) reject(result.value);
      return capability.promise;
    },
    // `Promise.race` method
    // https://tc39.github.io/ecma262/#sec-promise.race
    race: function race(iterable) {
      var C = this;
      var capability = newPromiseCapability$1(C);
      var reject = capability.reject;
      var result = perform(function () {
        var $promiseResolve = aFunction$1(C.resolve);
        iterate_1(iterable, function (promise) {
          $promiseResolve.call(C, promise).then(capability.resolve, reject);
        });
      });
      if (result.error) reject(result.value);
      return capability.promise;
    },
  }
);

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC =
  !!nativePromiseConstructor &&
  fails(function () {
    nativePromiseConstructor.prototype["finally"].call(
      {
        then: function () {
          /* empty */
        },
      },
      function () {
        /* empty */
      }
    );
  });

// `Promise.prototype.finally` method
// https://tc39.github.io/ecma262/#sec-promise.prototype.finally
_export(
  { target: "Promise", proto: true, real: true, forced: NON_GENERIC },
  {
    finally: function (onFinally) {
      var C = speciesConstructor(this, getBuiltIn("Promise"));
      var isFunction = typeof onFinally == "function";
      return this.then(
        isFunction
          ? function (x) {
              return promiseResolve(C, onFinally()).then(function () {
                return x;
              });
            }
          : onFinally,
        isFunction
          ? function (e) {
              return promiseResolve(C, onFinally()).then(function () {
                throw e;
              });
            }
          : onFinally
      );
    },
  }
);

// patch native Promise.prototype for native async functions
if (
  typeof nativePromiseConstructor == "function" &&
  !nativePromiseConstructor.prototype["finally"]
) {
  redefine(
    nativePromiseConstructor.prototype,
    "finally",
    getBuiltIn("Promise").prototype["finally"]
  );
}

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$3 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
    first = S.charCodeAt(position);
    return first < 0xd800 ||
      first > 0xdbff ||
      position + 1 === size ||
      (second = S.charCodeAt(position + 1)) < 0xdc00 ||
      second > 0xdfff
      ? CONVERT_TO_STRING
        ? S.charAt(position)
        : first
      : CONVERT_TO_STRING
      ? S.slice(position, position + 2)
      : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$3(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$3(true),
};

var charAt = stringMultibyte.charAt;

var STRING_ITERATOR = "String Iterator";
var setInternalState$2 = internalState.set;
var getInternalState$2 = internalState.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(
  String,
  "String",
  function (iterated) {
    setInternalState$2(this, {
      type: STRING_ITERATOR,
      string: String(iterated),
      index: 0,
    });
    // `%StringIteratorPrototype%.next` method
    // https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
  },
  function next() {
    var state = getInternalState$2(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return { value: undefined, done: true };
    point = charAt(string, index);
    state.index += point.length;
    return { value: point, done: false };
  }
);

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0,
};

var ITERATOR$5 = wellKnownSymbol("iterator");
var TO_STRING_TAG$3 = wellKnownSymbol("toStringTag");
var ArrayValues = es_array_iterator.values;

for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$5] !== ArrayValues)
      try {
        createNonEnumerableProperty(CollectionPrototype, ITERATOR$5, ArrayValues);
      } catch (error) {
        CollectionPrototype[ITERATOR$5] = ArrayValues;
      }
    if (!CollectionPrototype[TO_STRING_TAG$3]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$3, COLLECTION_NAME);
    }
    if (domIterables[COLLECTION_NAME])
      for (var METHOD_NAME in es_array_iterator) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[METHOD_NAME] !== es_array_iterator[METHOD_NAME])
          try {
            createNonEnumerableProperty(
              CollectionPrototype,
              METHOD_NAME,
              es_array_iterator[METHOD_NAME]
            );
          } catch (error) {
            CollectionPrototype[METHOD_NAME] = es_array_iterator[METHOD_NAME];
          }
      }
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true,
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}

function _toConsumableArray(arr) {
  return (
    _arrayWithoutHoles(arr) ||
    _iterableToArray(arr) ||
    _unsupportedIterableToArray(arr) ||
    _nonIterableSpread()
  );
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError(
    "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
  );
}

function _nonIterableRest() {
  throw new TypeError(
    "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
  );
}

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return (
    !!method &&
    fails(function () {
      // eslint-disable-next-line no-useless-call,no-throw-literal
      method.call(
        null,
        argument ||
          function () {
            throw 1;
          },
        1
      );
    })
  );
};

var $forEach = arrayIteration.forEach;

var STRICT_METHOD = arrayMethodIsStrict("forEach");
var USES_TO_LENGTH$2 = arrayMethodUsesToLength("forEach");

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
var arrayForEach =
  !STRICT_METHOD || !USES_TO_LENGTH$2
    ? function forEach(callbackfn /* , thisArg */) {
        return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      }
    : [].forEach;

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
_export(
  { target: "Array", proto: true, forced: [].forEach != arrayForEach },
  {
    forEach: arrayForEach,
  }
);

var defaultConfig = {
  // embedded_svc initialization parameters
  baseCoreURL: "https://liquidweb.my.salesforce.com",
  communityEndpointURL: "https://help.liquidweb.com/public",
  gslbBaseURL: "https://service.force.com",
  orgId: "00D30000000pmDy",
  eswConfigDevName: "Nexcess",
  // TODO - use LW as default
  settings: {
    baseLiveAgentContentURL: "https://c.la3-c2-ph2.salesforceliveagent.com/content",
    deploymentId: "5720c0000004aCZ",
    buttonId: "5733a00000000EN",
    // TODO - get LW default button id
    baseLiveAgentURL: "https://d.la3-c2-ph2.salesforceliveagent.com/chat",
    eswLiveAgentDevName: "EmbeddedServiceLiveAgent_Parent04I3a0000008OJXEA2_174e9c371a7",
    isOfflineSupportEnabled: false,
    chatbotAvatarImgURL: "https://media.liquidweb.com/salesforce/img/liquid-web-logo.jpg",
  },
  // Embedded Service for Web script location
  eswScriptURL: "https://service.force.com/embeddedservice/5.0/esw.min.js",
  // Whether the built in chat button should be used
  displayHelpButton: false,
  // Registrable domain where embedded_svc should store its cookies
  storageDomain: "liquidweb.com",
  // When the chat button is clicked, the amount of time
  // to wait for the ESW script to report "ready" before
  // assuming something went wrong. Not necessarily a hard
  // failure. The user could just have a slow connection.
  chatStartTimeout: 30000,
  // One of:
  //   dataLayer         Google Tag Manager dataLayer events
  //   googleAnalytics   Send events to Google Analytics directly
  analyticsMode: "dataLayer",
  // The context for web analytics action names (context:object_action)
  analyticsActionContext: "lw",
  // Disable if Google Analytics is not implemented.
  useGoogleAnalytics: true,
  // Amount of time to wait for Google Analytics to return
  // a tracker object. The script may block for up to this
  // duration in some situations, such as when an ad blocker
  // has replaced window.ga with a no-op function.
  googleAnalyticsTrackerTimeout: 2500,
  // Determines display details for the pre-chat survey
  preselectDepartment: null,
  // Whether HTML and style rules for proactive chat
  // invitations should be added to the document during
  // initialization.
  injectInvitationUI: false,
  invitationUIHeaderText: "Need help?",
  invitationUIBodyText: "We're Here To Help You",
};

var currentConfig = defaultConfig;

var mergeConfig = function mergeConfig(newConfig) {
  currentConfig = _objectSpread2(
    _objectSpread2(_objectSpread2({}, currentConfig), newConfig),
    {},
    {
      settings: _objectSpread2(_objectSpread2({}, currentConfig.settings), newConfig.settings),
    }
  );
  return currentConfig;
};

var getAllConfig = function getAllConfig() {
  return currentConfig;
};

var getConfig = function getConfig(key) {
  return currentConfig[key];
};

var injectScript = function injectScript(src) {
  return new Promise(function (resolve, reject) {
    var scriptEl = document.createElement("script");
    scriptEl.src = src;
    scriptEl.async = true;

    scriptEl.onload = function () {
      return resolve(scriptEl);
    };

    scriptEl.onerror = function () {
      return reject(new Error("Failed to load ".concat(src)));
    };

    document.head.appendChild(scriptEl);
  });
};

var componentEmitter = createCommonjsModule(function (module) {
  /**
   * Expose `Emitter`.
   */

  {
    module.exports = Emitter;
  }

  /**
   * Initialize a new `Emitter`.
   *
   * @api public
   */

  function Emitter(obj) {
    if (obj) return mixin(obj);
  }
  /**
   * Mixin the emitter properties.
   *
   * @param {Object} obj
   * @return {Object}
   * @api private
   */

  function mixin(obj) {
    for (var key in Emitter.prototype) {
      obj[key] = Emitter.prototype[key];
    }
    return obj;
  }

  /**
   * Listen on the given `event` with `fn`.
   *
   * @param {String} event
   * @param {Function} fn
   * @return {Emitter}
   * @api public
   */

  Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks["$" + event] = this._callbacks["$" + event] || []).push(fn);
    return this;
  };

  /**
   * Adds an `event` listener that will be invoked a single
   * time then automatically removed.
   *
   * @param {String} event
   * @param {Function} fn
   * @return {Emitter}
   * @api public
   */

  Emitter.prototype.once = function (event, fn) {
    function on() {
      this.off(event, on);
      fn.apply(this, arguments);
    }

    on.fn = fn;
    this.on(event, on);
    return this;
  };

  /**
   * Remove the given callback for `event` or all
   * registered callbacks.
   *
   * @param {String} event
   * @param {Function} fn
   * @return {Emitter}
   * @api public
   */

  Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (
    event,
    fn
  ) {
    this._callbacks = this._callbacks || {};

    // all
    if (0 == arguments.length) {
      this._callbacks = {};
      return this;
    }

    // specific event
    var callbacks = this._callbacks["$" + event];
    if (!callbacks) return this;

    // remove all handlers
    if (1 == arguments.length) {
      delete this._callbacks["$" + event];
      return this;
    }

    // remove specific handler
    var cb;
    for (var i = 0; i < callbacks.length; i++) {
      cb = callbacks[i];
      if (cb === fn || cb.fn === fn) {
        callbacks.splice(i, 1);
        break;
      }
    }

    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) {
      delete this._callbacks["$" + event];
    }

    return this;
  };

  /**
   * Emit `event` with the given args.
   *
   * @param {String} event
   * @param {Mixed} ...
   * @return {Emitter}
   */

  Emitter.prototype.emit = function (event) {
    this._callbacks = this._callbacks || {};

    var args = new Array(arguments.length - 1),
      callbacks = this._callbacks["$" + event];

    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }

    if (callbacks) {
      callbacks = callbacks.slice(0);
      for (var i = 0, len = callbacks.length; i < len; ++i) {
        callbacks[i].apply(this, args);
      }
    }

    return this;
  };

  /**
   * Return array of callbacks for `event`.
   *
   * @param {String} event
   * @return {Array}
   * @api public
   */

  Emitter.prototype.listeners = function (event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks["$" + event] || [];
  };

  /**
   * Check if this emitter has `event` handlers.
   *
   * @param {String} event
   * @return {Boolean}
   * @api public
   */

  Emitter.prototype.hasListeners = function (event) {
    return !!this.listeners(event).length;
  };
});

var emitter = new componentEmitter();

var watchableEmbeddedServiceEvents = [
  "onAgentJoinedConference",
  "onAgentLeftConference",
  "onAgentMessage",
  "onAgentRichMessage",
  "onChasitorMessage",
  "onChatConferenceEnded",
  "onChatConferenceInitiated",
  "onChatEndedByAgent",
  "onChatEndedByChasitor",
  "onChatReconnectSuccessful",
  "onChatRequestSuccess",
  "onChatTransferSuccessful",
  "onConnectionError",
  "onIdleTimeoutOccurred",
  "onQueueUpdate",
  "onClickSubmitButton",
  "onHelpButtonClick",
  "onInviteAccepted",
  "onInviteRejected",
  "afterInit",
  "ready",
];
var loadPromise = null;

var loadEmbeddedSvc = function loadEmbeddedSvc() {
  if (loadPromise) return loadPromise;
  if (window.embedded_svc) return Promise.resolve();
  var url = getConfig("eswScriptURL");
  loadPromise = injectScript(url).catch(function (err) {
    emitter.emit("LWESWScriptLoadFailure");
    throw err;
  });
  return loadPromise;
};

var getEmbeddedSvc = function getEmbeddedSvc() {
  if (window.embedded_svc) return Promise.resolve(window.embedded_svc);
  return loadEmbeddedSvc().then(function () {
    return window.embedded_svc;
  });
};

var watchEmbeddedServiceEvents = function watchEmbeddedServiceEvents() {
  var emit = emitter.emit;
  return getEmbeddedSvc().then(function (embeddedSvc) {
    watchableEmbeddedServiceEvents.forEach(function (eventName) {
      embeddedSvc.addEventHandler(eventName, emit.bind(emitter, eventName));
    });
  });
};

var createProperty = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object)
    objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var IS_CONCAT_SPREADABLE = wellKnownSymbol("isConcatSpreadable");
var MAX_SAFE_INTEGER = 0x1fffffffffffff;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = "Maximum allowed index exceeded";

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT =
  engineV8Version >= 51 ||
  !fails(function () {
    var array = [];
    array[IS_CONCAT_SPREADABLE] = false;
    return array.concat()[0] !== array;
  });

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("concat");

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED$1 = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
_export(
  { target: "Array", proto: true, forced: FORCED$1 },
  {
    // eslint-disable-line no-unused-vars
    concat: function concat() {
      var O = toObject(this);
      var A = arraySpeciesCreate(O, 0);
      var n = 0;
      var i, k, length, len, E;
      for (i = -1, length = arguments.length; i < length; i++) {
        E = i === -1 ? O : arguments[i];
        if (isConcatSpreadable(E)) {
          len = toLength(E.length);
          if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
          for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
        } else {
          if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
          createProperty(A, n++, E);
        }
      }
      A.length = n;
      return A;
    },
  }
);

var FAILS_ON_PRIMITIVES = fails(function () {
  objectKeys(1);
});

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
_export(
  { target: "Object", stat: true, forced: FAILS_ON_PRIMITIVES },
  {
    keys: function keys(it) {
      return objectKeys(toObject(it));
    },
  }
);

for (var COLLECTION_NAME$1 in domIterables) {
  var Collection$1 = global_1[COLLECTION_NAME$1];
  var CollectionPrototype$1 = Collection$1 && Collection$1.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype$1 && CollectionPrototype$1.forEach !== arrayForEach)
    try {
      createNonEnumerableProperty(CollectionPrototype$1, "forEach", arrayForEach);
    } catch (error) {
      CollectionPrototype$1.forEach = arrayForEach;
    }
}

var getGoogleAnalyticsObjectName = function getGoogleAnalyticsObjectName() {
  window.GoogleAnalyticsObject = window.GoogleAnalyticsObject || "ga";
  return window.GoogleAnalyticsObject;
};
/**
 * If Google Analytics has not yet completed the first phase
 * of its initialization, stub window.ga() so that we can begin
 * accepting commands.
 *
 * This method partially implements the standard analytics.js
 * code snippet.
 *
 * Be aware that commands enqueued using this stub will execute
 * before the ga('create', ...) command has run, meaning the tracker
 * object will not yet exist.
 */

var maybeStubGoogleAnalytics = function maybeStubGoogleAnalytics() {
  var gaName = getGoogleAnalyticsObjectName();
  if (window[gaName]) return;
  /* eslint-disable func-names, prefer-rest-params */

  window[gaName] =
    window[gaName] ||
    function () {
      window[gaName].q = window[gaName].q || [];
      window[gaName].q.push(arguments);
    };
  /* eslint-enable func-names, prefer-rest-params */

  window[gaName].l = new Date().getTime();
};

var getGoogleAnalyticsObject = function getGoogleAnalyticsObject() {
  var useGoogleAnalytics = getConfig("useGoogleAnalytics");
  if (!useGoogleAnalytics) return undefined;
  maybeStubGoogleAnalytics();
  var gaName = getGoogleAnalyticsObjectName();
  return window[gaName];
};

var awaitGAReadyPromise;

var awaitGoogleAnalyticsReady = function awaitGoogleAnalyticsReady() {
  if (awaitGAReadyPromise) return awaitGAReadyPromise;
  var ga = getGoogleAnalyticsObject();
  if (!ga) return Promise.resolve(undefined);
  var trackerTimeout = getConfig("googleAnalyticsTrackerTimeout");
  awaitGAReadyPromise = new Promise(function (resolve, reject) {
    ga(function (tracker) {
      // Force into the next event loop to ensure all commands
      // in the command queue have run before any callbacks
      // waiting for this promise to resolve.
      setTimeout(function () {
        return resolve(tracker);
      });
    });
    setTimeout(reject, trackerTimeout);
  }).catch(function () {
    return (
      // Fail gracefully in case of timeout
      Promise.resolve(undefined)
    );
  });
  return awaitGAReadyPromise;
};

var getTrackerPromise;

var getTracker = function getTracker() {
  if (getTrackerPromise) return getTrackerPromise;
  getTrackerPromise = awaitGoogleAnalyticsReady().then(function (tracker) {
    if (tracker) return tracker;
    var ga = getGoogleAnalyticsObject(); // It's possible (if we're relying on the GA stub)
    // that the tracker had not yet been created when
    // this callback was invoked. It may exist now,
    // however, given that we're in the next event loop.

    if (typeof ga.getAll === "function") {
      return ga.getAll()[0];
    }

    return undefined;
  });
  return getTrackerPromise;
};

var getClientId = function getClientId() {
  return getTracker().then(function (tracker) {
    return tracker ? tracker.get("clientId") : undefined;
  });
};

var getTrackingId = function getTrackingId() {
  return getTracker().then(function (tracker) {
    return tracker ? tracker.get("trackingId") : undefined;
  });
};

var sendEvent = function sendEvent(_ref) {
  var category = _ref.category,
    action = _ref.action,
    label = _ref.label;
  return getTracker().then(function (tracker) {
    if (!tracker) return;
    tracker.send("event", category, action, label);
  });
};

var DEFAULT_EVENT_CATEGORY = "chat";
var DATALAYER_EVENT_NAME = "lw.structured";
var DATALAYER_NAME = "dataLayer";
var analyticsEvents = {
  onAgentJoinedConference: {
    action: "agent_joined",
  },
  onAgentLeftConference: {
    action: "agent_left",
  },
  onAgentMessage: {
    action: "message_sent",
    label: "agent",
  },
  onChasitorMessage: {
    action: "message_sent",
    label: "chasitor",
  },
  onChatConferenceEnded: {
    action: "conference_ended",
  },
  onChatConferenceInitiated: {
    action: "conference_initiated",
  },
  onChatEndedByAgent: {
    action: "chat_ended",
    label: "agent",
  },
  onChatEndedByChasitor: {
    action: "chat_ended",
    label: "chasitor",
  },
  onChatReconnectSuccessful: {
    action: "chat_reconnected",
  },
  onChatRequestSuccess: {
    action: "chat_succeeded",
  },
  onChatTransferSuccessful: {
    action: "chat_transferred",
  },
  onConnectionError: {
    action: "error_occurred",
    label: "connection",
  },
  onIdleTimeoutOccurred: {
    action: "timeout_occurred",
    label: "idle",
  },
  onQueueUpdate: {
    action: "queue_updated",
  },
  onClickSubmitButton: {
    action: "submitButton_clicked",
  },
  onHelpButtonClick: {
    action: "helpButton_clicked",
  },
  onInviteAccepted: {
    action: "invite_accepted",
  },
  onInviteRejected: {
    action: "invite_rejected",
  },
  LWButtonClickTimeout: {
    action: "timeout_occurred",
    label: "click",
  },
  LWESWScriptLoadFailure: {
    action: "error_occurred",
    label: "scriptLoadFailure",
  },
  LWPrechatSurveySubmitted: {
    action: "prechatSurvey_submitted",
    getLabel: function getLabel() {
      var _data$find;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return (_data$find = data.find(function (i) {
        return i.label === "Department";
      })) === null || _data$find === void 0
        ? void 0
        : _data$find.value;
    },
  },
};

var sendDataLayerEvent = function sendDataLayerEvent(_ref) {
  var category = _ref.category,
    action = _ref.action,
    label = _ref.label;
  return window[DATALAYER_NAME].push({
    event: DATALAYER_EVENT_NAME,
    data: {
      category: category,
      action: action,
      label: label,
    },
  });
};

var sendEvent$1 = function sendEvent$1(_ref2) {
  var _ref2$category = _ref2.category,
    category = _ref2$category === void 0 ? DEFAULT_EVENT_CATEGORY : _ref2$category,
    action = _ref2.action,
    label = _ref2.label;

  var _getAllConfig = getAllConfig(),
    analyticsMode = _getAllConfig.analyticsMode,
    analyticsActionContext = _getAllConfig.analyticsActionContext;

  var actionWithContext = "".concat(analyticsActionContext, ":").concat(action);

  switch (analyticsMode) {
    case "googleAnalytics":
      sendEvent({
        category: category,
        action: actionWithContext,
        label: label,
      });
      break;

    case "dataLayer":
      sendDataLayerEvent({
        category: category,
        action: actionWithContext,
        label: label,
      });
      break;
  }
};

var handleEvent = function handleEvent(eventName, data) {
  var _analyticsEvents$even = analyticsEvents[eventName],
    action = _analyticsEvents$even.action,
    label = _analyticsEvents$even.label,
    getLabel = _analyticsEvents$even.getLabel;
  if (!action) return;

  if (typeof getLabel === "function") {
    sendEvent$1({
      action: action,
      label: getLabel(data),
    });
    return;
  }

  sendEvent$1({
    action: action,
    label: label,
  });
};

var watchEvents = function watchEvents() {
  Object.keys(analyticsEvents).forEach(function (eventName) {
    emitter.on(eventName, handleEvent.bind(null, eventName));
  });
};

var maybeStubDatalayer = function maybeStubDatalayer() {
  var analyticsMode = getConfig("analyticsMode");

  if (analyticsMode === "dataLayer") {
    window[DATALAYER_NAME] = window[DATALAYER_NAME] || [];
  }
};

var init = function init() {
  maybeStubDatalayer();
  watchEvents();
};

var CONTAINER_ELEMENT_ID = "lw-chat-invitation-container";

var getHTML = function getHTML() {
  var _getAllConfig = getAllConfig(),
    headerText = _getAllConfig.invitationUIHeaderText,
    bodyText = _getAllConfig.invitationUIBodyText;

  return '\n\t\t<div class="embeddedServiceInvitation" id="snapins_invite" inert="true" aria-live="assertive" role="dialog" aria-atomic="true">\n\t\t\t<div class="embeddedServiceInvitationHeader" aria-labelledby="snapins_titletext" aria-describedby="snapins_bodytext">\n\t\t\t\t<img id="embeddedServiceAvatar"></img>\n\t\t\t\t<span class="embeddedServiceTitleText" id="snapins_titletext">'
    .concat(
      headerText,
      '</span>\n\t\t\t\t<button type="button" id="closeInvite" class="embeddedServiceCloseIcon" aria-label="Exit invitation">&times;</button>\n\t\t\t</div>\n\t\t\t<div class="embeddedServiceInvitationBody">\n\t\t\t\t<p id="snapins_bodytext">'
    )
    .concat(
      bodyText,
      '</p>\n\t\t\t</div>\n\t\t\t<div class="embeddedServiceInvitationFooter" aria-describedby="snapins_bodytext">\n\t\t\t\t<button type="button" class="embeddedServiceActionButton" id="rejectInvite">Close</button>\n\t\t\t\t<button type="button" class="embeddedServiceActionButton" id="acceptInvite">Start Chat</button>\n\t\t\t</div>\n\t\t</div>\n\t'
    );
};

var injectHTML = function injectHTML() {
  var containerEl = document.createElement("div");
  containerEl.id = CONTAINER_ELEMENT_ID;
  containerEl.innerHTML = getHTML();
  document.body.appendChild(containerEl);
};

var getCSS = function getCSS() {
  return '\n\t#snapins_invite { background-color: #FFFFFF; font-family: "Verdana", sans-serif; overflow: visible; border-radius: 8px; visibility: hidden; }\n\t.embeddedServiceInvitation { background-color: transparent; max-width: 290px; max-height: 210px; -webkit-box-shadow: 0 7px 12px rgba(0,0,0,0.28); -moz-box-shadow: 0 7px 12px rgba(0,0,0,0.28); box-shadow: 0 7px 12px rgba(0,0,0,0.28); }\n\t@media only screen and (min-width: 48em) { /*mobile*/ .embeddedServiceInvitation { max-width: 332px; max-height: 210px; } }\n\t.embeddedServiceInvitation > .embeddedServiceInvitationHeader { width: inherit; height: 32px; line-height: 32px; padding: 10px; color: #FFFFFF; background-color: #7E7E7E; overflow: initial; display: flex; justify-content: space-between; align-items: stretch; border-top-left-radius: 8px; border-top-right-radius: 8px; }\n\t.embeddedServiceInvitationHeader #embeddedServiceAvatar { width: 32px; height: 32px; border-radius: 50%; }\n\t.embeddedServiceInvitationHeader .embeddedServiceTitleText { font-size: 18px; color: #FFFFFF; overflow: hidden; word-wrap: normal; white-space: nowrap; text-overflow: ellipsis; align-self: stretch; flex-grow: 1; max-width: 100%; margin: 0 12px; }\n\t.embeddedServiceInvitationHeader .embeddedServiceCloseIcon { border: none; border-radius: 3px; cursor: pointer; position: relative; bottom: 3%; background-color: transparent; width: 32px; height: 32px; font-size: 23px; color: #FFFFFF; }\n\t.embeddedServiceInvitationHeader .embeddedServiceCloseIcon:focus { outline: none; }\n\t.embeddedServiceInvitationHeader .embeddedServiceCloseIcon:focus::before { content: " "; position: absolute; top: 11%; left: 7%; width: 85%; height: 85%; background-color: rgba(255, 255, 255, 0.2); border-radius: 4px; pointer-events: none; }\n\t.embeddedServiceInvitationHeader .embeddedServiceCloseIcon:active, .embeddedServiceCloseIcon:hover { background-color: #FFFFFF; color: rgba(0,0,0,0.7); opacity: 0.7; }\n\t.embeddedServiceInvitation > .embeddedServiceInvitationBody { background-color: #FFFFFF; max-height: 110px; min-width: 260px; margin: 0 8px; font-size: 14px; line-height: 20px; overflow: auto; }\n\t.embeddedServiceInvitationBody p { color: #333333; padding: 8px; margin: 12px 0; }\n\t.embeddedServiceInvitation > .embeddedServiceInvitationFooter { width: inherit; color: #FFFFFF; text-align: right; background-color: #FFFFFF; padding: 10px; max-height: 50px; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px; }\n\t.embeddedServiceInvitationFooter > .embeddedServiceActionButton { font-size: 14px; max-height: 40px; border: none; border-radius: 4px; padding: 10px; margin: 4px; text-align: center; text-decoration: none; display: inline-block; cursor: pointer; }\n\t.embeddedServiceInvitationFooter > #acceptInvite { background-color: #00aeff; color: #FFFFFF; }\n\t.embeddedServiceInvitationFooter > #rejectInvite { background-color: #FFFFFF; color: #00aeff; }\n';
};

var injectCSS = function injectCSS() {
  var css = getCSS();
  var cssTextNode = document.createTextNode(css);
  var styleEl = document.createElement("style");
  styleEl.type = "text/css";
  styleEl.appendChild(cssTextNode);
  document.head.appendChild(styleEl);
};

var handleAcceptInvite = function handleAcceptInvite() {
  getEmbeddedSvc().then(function (embeddedSvc) {
    embeddedSvc.inviteAPI.inviteButton.acceptInvite();
  });
};

var handleRejectInvite = function handleRejectInvite() {
  getEmbeddedSvc().then(function (embeddedSvc) {
    embeddedSvc.inviteAPI.inviteButton.rejectInvite();
  });
};

var addEventListeners = function addEventListeners() {
  document.getElementById("closeInvite").addEventListener("click", handleRejectInvite);
  document.getElementById("rejectInvite").addEventListener("click", handleRejectInvite);
  document.getElementById("acceptInvite").addEventListener("click", handleAcceptInvite);
};

var init$1 = function init() {
  if (!getConfig("injectInvitationUI")) return;

  if (document.getElementById("snapins_invite")) {
    throw new Error("Unable to inject invitation UI. #snapins_invite already exists.");
  }

  injectCSS();
  injectHTML();
  addEventListeners();
};

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (
  target,
  original,
  source,
  sourceLen,
  start,
  depth,
  mapper,
  thisArg
) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? functionBindContext(mapper, thisArg, 3) : false;
  var element;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        targetIndex =
          flattenIntoArray(
            target,
            original,
            element,
            toLength(element.length),
            targetIndex,
            depth - 1
          ) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError("Exceed the acceptable array length");
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray;

// `Array.prototype.flat` method
// https://github.com/tc39/proposal-flatMap
_export(
  { target: "Array", proto: true },
  {
    flat: function flat(/* depthArg = 1 */) {
      var depthArg = arguments.length ? arguments[0] : undefined;
      var O = toObject(this);
      var sourceLen = toLength(O.length);
      var A = arraySpeciesCreate(O, 0);
      A.length = flattenIntoArray_1(
        A,
        O,
        O,
        sourceLen,
        0,
        depthArg === undefined ? 1 : toInteger(depthArg)
      );
      return A;
    },
  }
);

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module

addToUnscopables("flat");

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = "";
  if (that.global) result += "g";
  if (that.ignoreCase) result += "i";
  if (that.multiline) result += "m";
  if (that.dotAll) result += "s";
  if (that.unicode) result += "u";
  if (that.sticky) result += "y";
  return result;
};

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

var UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE("a", "y");
  re.lastIndex = 2;
  return re.exec("abcd") != null;
});

var BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE("^r", "gy");
  re.lastIndex = 2;
  return re.exec("str") != null;
});

var regexpStickyHelpers = {
  UNSUPPORTED_Y: UNSUPPORTED_Y,
  BROKEN_CARET: BROKEN_CARET,
};

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, "a");
  nativeExec.call(re2, "a");
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = regexpStickyHelpers.UNSUPPORTED_Y || regexpStickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace("y", "");
      if (flags.indexOf("g") === -1) {
        flags += "g";
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || (re.multiline && str[re.lastIndex - 1] !== "\n"))) {
        source = "(?: " + source + ")";
        strCopy = " " + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp("^(?:" + source + ")", flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

var regexpExec = patchedExec;

_export(
  { target: "RegExp", proto: true, forced: /./.exec !== regexpExec },
  {
    exec: regexpExec,
  }
);

// TODO: Remove from `core-js@4` since it's moved to entry points

var SPECIES$5 = wellKnownSymbol("species");

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: "7" };
    return result;
  };
  return "".replace(re, "$<a>") !== "7";
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return "a".replace(/./, "$0") === "$0";
})();

var REPLACE = wellKnownSymbol("replace");
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]("a", "$0") === "";
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () {
    return originalExec.apply(this, arguments);
  };
  var result = "ab".split(re);
  return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
});

var fixRegexpWellKnownSymbolLogic = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () {
      return 7;
    };
    return ""[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC =
    DELEGATES_TO_SYMBOL &&
    !fails(function () {
      // Symbol-named RegExp methods call .exec
      var execCalled = false;
      var re = /a/;

      if (KEY === "split") {
        // We can't use real regex here since it causes deoptimization
        // and serious performance degradation in V8
        // https://github.com/zloirock/core-js/issues/306
        re = {};
        // RegExp[@@split] doesn't call the regex's exec method, but first creates
        // a new one. We need to return the patched regex when creating the new one.
        re.constructor = {};
        re.constructor[SPECIES$5] = function () {
          return re;
        };
        re.flags = "";
        re[SYMBOL] = /./[SYMBOL];
      }

      re.exec = function () {
        execCalled = true;
        return null;
      };

      re[SYMBOL]("");
      return !execCalled;
    });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === "replace" &&
      !(
        REPLACE_SUPPORTS_NAMED_GROUPS &&
        REPLACE_KEEPS_$0 &&
        !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
      )) ||
    (KEY === "split" && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(
      SYMBOL,
      ""[KEY],
      function (nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      },
      {
        REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
        REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE,
      }
    );
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(
      RegExp.prototype,
      SYMBOL,
      length == 2
        ? // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
          // 21.2.5.11 RegExp.prototype[@@split](string, limit)
          function (string, arg) {
            return regexMethod.call(string, this, arg);
          }
        : // 21.2.5.6 RegExp.prototype[@@match](string)
          // 21.2.5.9 RegExp.prototype[@@search](string)
          function (string) {
            return regexMethod.call(string, this);
          }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], "sham", true);
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === "function") {
    var result = exec.call(R, S);
    if (typeof result !== "object") {
      throw TypeError("RegExp exec method returned something other than an Object or null");
    }
    return result;
  }

  if (classofRaw(R) !== "RegExp") {
    throw TypeError("RegExp#exec called on incompatible receiver");
  }

  return regexpExec.call(R, S);
};

// @@match logic
fixRegexpWellKnownSymbolLogic("match", 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regexpExecAbstract(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regexpExecAbstract(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === "")
          rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    },
  ];
});

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    objectSetPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == "function" &&
    NewTarget !== Wrapper &&
    isObject((NewTargetPrototype = NewTarget.prototype)) &&
    NewTargetPrototype !== Wrapper.prototype
  )
    objectSetPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var MATCH = wellKnownSymbol("match");

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return (
    isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == "RegExp")
  );
};

var defineProperty$2 = objectDefineProperty.f;
var getOwnPropertyNames = objectGetOwnPropertyNames.f;

var setInternalState$3 = internalState.set;

var MATCH$1 = wellKnownSymbol("match");
var NativeRegExp = global_1.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y$2 = regexpStickyHelpers.UNSUPPORTED_Y;

var FORCED$2 =
  descriptors &&
  isForced_1(
    "RegExp",
    !CORRECT_NEW ||
      UNSUPPORTED_Y$2 ||
      fails(function () {
        re2[MATCH$1] = false;
        // RegExp constructor can alter flags and IsRegExp works correct with @@match
        return (
          NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, "i") != "/a/i"
        );
      })
  );

// `RegExp` constructor
// https://tc39.github.io/ecma262/#sec-regexp-constructor
if (FORCED$2) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegexp(pattern);
    var flagsAreUndefined = flags === undefined;
    var sticky;

    if (
      !thisIsRegExp &&
      patternIsRegExp &&
      pattern.constructor === RegExpWrapper &&
      flagsAreUndefined
    ) {
      return pattern;
    }

    if (CORRECT_NEW) {
      if (patternIsRegExp && !flagsAreUndefined) pattern = pattern.source;
    } else if (pattern instanceof RegExpWrapper) {
      if (flagsAreUndefined) flags = regexpFlags.call(pattern);
      pattern = pattern.source;
    }

    if (UNSUPPORTED_Y$2) {
      sticky = !!flags && flags.indexOf("y") > -1;
      if (sticky) flags = flags.replace(/y/g, "");
    }

    var result = inheritIfRequired(
      CORRECT_NEW ? new NativeRegExp(pattern, flags) : NativeRegExp(pattern, flags),
      thisIsRegExp ? this : RegExpPrototype,
      RegExpWrapper
    );

    if (UNSUPPORTED_Y$2 && sticky) setInternalState$3(result, { sticky: sticky });

    return result;
  };
  var proxy = function (key) {
    key in RegExpWrapper ||
      defineProperty$2(RegExpWrapper, key, {
        configurable: true,
        get: function () {
          return NativeRegExp[key];
        },
        set: function (it) {
          NativeRegExp[key] = it;
        },
      });
  };
  var keys$1 = getOwnPropertyNames(NativeRegExp);
  var index = 0;
  while (keys$1.length > index) proxy(keys$1[index++]);
  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global_1, "RegExp", RegExpWrapper);
}

// https://tc39.github.io/ecma262/#sec-get-regexp-@@species
setSpecies("RegExp");

var TO_STRING = "toString";
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails(function () {
  return nativeToString.call({ source: "a", flags: "b" }) != "/a/b";
});
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(
    RegExp.prototype,
    TO_STRING,
    function toString() {
      var R = anObject(this);
      var p = String(R.source);
      var rf = R.flags;
      var f = String(
        rf === undefined && R instanceof RegExp && !("flags" in RegExpPrototype$1)
          ? regexpFlags.call(R)
          : rf
      );
      return "/" + p + "/" + f;
    },
    { unsafe: true }
  );
}

var max$1 = Math.max;
var min$2 = Math.min;
var floor$1 = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
fixRegexpWellKnownSymbolLogic("replace", 2, function (
  REPLACE,
  nativeReplace,
  maybeCallNative,
  reason
) {
  var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE =
    reason.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE;
  var REPLACE_KEEPS_$0 = reason.REPLACE_KEEPS_$0;
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";

  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      if (
        (!REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE && REPLACE_KEEPS_$0) ||
        (typeof replaceValue === "string" && replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1)
      ) {
        var res = maybeCallNative(nativeReplace, regexp, this, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(regexp);
      var S = String(this);

      var functionalReplace = typeof replaceValue === "function";
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regexpExecAbstract(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === "")
          rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = "";
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max$1(min$2(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(
            matched,
            S,
            position,
            captures,
            namedCaptures,
            replaceValue
          );
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    },
  ];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return nativeReplace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case "$":
          return "$";
        case "&":
          return matched;
        case "`":
          return str.slice(0, position);
        case "'":
          return str.slice(tailPos);
        case "<":
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default:
          // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor$1(n / 10);
            if (f === 0) return match;
            if (f <= m)
              return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? "" : capture;
    });
  }
});

// HT https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
var getCookie = function getCookie(name) {
  return (
    decodeURIComponent(
      document.cookie.replace(
        new RegExp("(?:(?:^|.*;)\\s*".concat(name, "\\s*\\=\\s*([^;]*).*$)|^.*$")),
        "$1"
      )
    ) || null
  );
};

var getLWReferralData = function getLWReferralData() {
  var cookieValue = getCookie("lwReferralData");
  if (!cookieValue) return undefined;
  var cookieData = JSON.parse(cookieValue);

  switch (cookieData.program) {
    case "impact_radius":
      return {
        Network: cookieData.program,
        PartnerId: cookieData.irpid,
        AdId: cookieData.iradid,
        SubId: cookieData.sharedid,
        ClickId: cookieData.clickid,
      };

    case "awin":
      return {
        Network: cookieData.program,
        PartnerId: cookieData.awid,
        AdId: cookieData.aid,
        SubId: cookieData.sid,
        ClickId: cookieData.awc,
      };

    default:
      return undefined;
  }
};

var getCJReferralData = function getCJReferralData() {
  var pidCookie = getCookie("CJPIDLW");
  var eventCookie = getCookie("CJEVENTLW");
  if (!pidCookie) return undefined;
  var fields = pidCookie.match(/pid=([^&]+)&aid=([^&]+)?&sid=([^&]+)?/);
  if (!fields) return undefined;
  return {
    Network: "cj",
    PartnerId: fields[1],
    AdId: fields[2],
    SubId: fields[3],
    ClickId: eventCookie,
  };
};

var getAffiliateData = function getAffiliateData() {
  return getLWReferralData() || getCJReferralData();
};

var getInitialExtraDetails = function getInitialExtraDetails() {
  var affiliateData = getAffiliateData();
  if (!affiliateData) return [];
  return Object.entries(affiliateData).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

    return {
      label: "Affiliate".concat(key, "__c"),
      value: value,
      displayToAgent: true,
      transcriptFields: ["Affiliate".concat(key, "__c")],
    };
  });
};

var getInitialExtraDetails$1 = function getInitialExtraDetails() {
  return [
    {
      label: "ChatAuthToken",
      value: "",
      displayToAgent: false,
      transcriptFields: ["Chat_Auth_Token__c"],
    },
  ];
};

var getInitialExtraDetails$2 = function getInitialExtraDetails() {
  var cookieValue = getCookie("LW_COUPON");
  if (!cookieValue) return [];
  var fields = cookieValue.match(/([^|]+)|/);
  if (!fields) return [];
  var couponCode = fields[1];
  if (!couponCode) return [];
  return [
    {
      label: "SessionCouponCode__c",
      value: couponCode,
      displayToAgent: true,
      transcriptFields: ["SessionCouponCode__c"],
    },
  ];
};

var formatDetails = function formatDetails(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    clientId = _ref2[0],
    trackingId = _ref2[1];

  if (!clientId || !trackingId) {
    return [
      {
        label: "googleTrackingUnavailable",
        value: true,
        displayToAgent: false,
      },
    ];
  }

  return [
    {
      label: "googleClientId",
      value: clientId,
      displayToAgent: true,
      transcriptFields: ["Google_Client_Id__c"],
    },
    {
      label: "googleTrackingId",
      value: trackingId,
      displayToAgent: true,
      transcriptFields: ["Google_Tracking_Id__c"],
    },
  ];
};

var getInitialExtraDetails$3 = function getInitialExtraDetails() {
  return Promise.all([getClientId(), getTrackingId()]).then(formatDetails);
};

var getInitialExtraDetails$4 = function getInitialExtraDetails() {
  var piiCookie = getCookie("lwPiiPreferences");
  if (!piiCookie) return [];
  var piiDetails = JSON.parse(piiCookie);
  return Object.entries(piiDetails).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

    return {
      label: "piiPref_".concat(key),
      value: value,
      displayToAgent: false,
    };
  });
};

var getInitialExtraDetails$5 = function getInitialExtraDetails() {
  var preselectDepartment = getConfig("preselectDepartment");
  if (!preselectDepartment) return [];
  return [
    {
      label: "preselectDepartment",
      value: preselectDepartment,
      displayToAgent: false,
    },
  ];
};

var $filter = arrayIteration.filter;

var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport("filter");
// Edge 14- issue
var USES_TO_LENGTH$3 = arrayMethodUsesToLength("filter");

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
_export(
  { target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT$1 || !USES_TO_LENGTH$3 },
  {
    filter: function filter(callbackfn /* , thisArg */) {
      return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
  }
);

var cookieToSalesforceFieldMap = {
  _utma: "Google_Utma__c",
  _utmc: "Google_Utmc__c",
  _utmz: "Google_Utmz__c",
  utm_source: "Google_Utm_Source__c",
  utm_medium: "Google_Utm_Medium__c",
  utm_channel: "Google_Utm_Channel__c",
  utm_campaign: "Google_Utm_Campaign__c",
  gclid: "Google_Gclid__c",
};

var getInitialExtraDetails$6 = function getInitialExtraDetails() {
  return Object.entries(cookieToSalesforceFieldMap)
    .map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        cookieName = _ref2[0],
        fieldName = _ref2[1];

      return {
        label: fieldName,
        value: getCookie(cookieName),
        displayToAgent: true,
        transcriptFields: [fieldName],
      };
    })
    .filter(function (detail) {
      return detail.value !== null;
    });
};

var getInitialExtraDetails$7 = function getInitialExtraDetails() {
  return [
    {
      label: "googlePageUrl",
      value: window.location.href,
      displayToAgent: true,
      transcriptFields: ["Google_Page_Url__c"],
    },
  ];
};

var getInitialPrechatFormDetails = function getInitialPrechatFormDetails() {
  return [
    {
      label: "Route To",
      value: "",
      transcriptFields: ["RouteTo__c"],
    },
    {
      label: "Account Id",
      value: "",
      transcriptFields: ["AccountId"],
    },
    {
      label: "Contact Id",
      value: "",
      transcriptFields: ["ContactId"],
    },
    {
      label: "Name",
      value: "",
      transcriptFields: ["Visitor_Name__c"],
    },
    {
      label: "Email",
      value: "",
      transcriptFields: ["Visitor_s_Email__c"],
    },
    {
      label: "How Help",
      value: "",
      transcriptFields: ["How_Can_We_Help__c"],
    },
    {
      label: "Company",
      value: "",
      transcriptFields: ["Company__c"],
    },
    {
      label: "Subject",
      value: "",
      transcriptFields: ["Subject__c"],
    },
    {
      label: "Department",
      value: "",
      transcriptFields: ["Requested_Department__c"],
    },
    {
      label: "PII Restricted Country",
      value: "",
      transcriptFields: ["PII_Restricted_Country__c"],
    },
    {
      label: "PII Data Processing",
      value: "",
      transcriptFields: ["PII_Data_Processing__c"],
    },
    {
      label: "PII Contact",
      value: "",
      transcriptFields: ["PII_Marketing_Contact__c"],
    },
    {
      label: "PII Detected Country",
      value: "",
      transcriptFields: ["PII_Detected_Country__c"],
    },
    {
      label: "Authenticated",
      value: "",
      transcriptFields: ["Authentication_Status__c"],
    },
    {
      label: "Type",
      value: "",
      transcriptFields: ["Type__c"],
    },
    {
      label: "SubType",
      value: "",
      transcriptFields: ["SubType__c"],
    },
    {
      label: "SupportPIN",
      value: "",
      transcriptFields: ["Visitor_PIN__c"],
    },
    {
      label: "AccountNumber",
      value: "",
      transcriptFields: ["Visitor_Account_Number__c"],
    },
  ];
};

var getInitialAsyncDetails = function getInitialAsyncDetails() {
  return Promise.all([getInitialExtraDetails$3()]).then(function (results) {
    return results.flat();
  });
};

var getInitialExtraDetails$8 = function getInitialExtraDetails$3() {
  return getInitialAsyncDetails().then(function (asyncDetails) {
    return [].concat(
      _toConsumableArray(asyncDetails),
      _toConsumableArray(getInitialExtraDetails()),
      _toConsumableArray(getInitialExtraDetails$1()),
      _toConsumableArray(getInitialExtraDetails$2()),
      _toConsumableArray(getInitialExtraDetails$4()),
      _toConsumableArray(getInitialExtraDetails$5()),
      _toConsumableArray(getInitialExtraDetails$6()),
      _toConsumableArray(getInitialExtraDetails$7()),
      _toConsumableArray(getInitialPrechatFormDetails())
    );
  });
};

var getExtraDetail = function getExtraDetail(label) {
  return getEmbeddedSvc().then(function (embeddedSvc) {
    var extraPrechatFormDetails = embeddedSvc.settings.extraPrechatFormDetails;
    if (!extraPrechatFormDetails) return undefined;
    return extraPrechatFormDetails.find(function (detail) {
      return detail.label === label;
    });
  });
};

var updateExtraDetail = function updateExtraDetail(label, value) {
  return getExtraDetail(label).then(function (detail) {
    if (!detail) return undefined; // eslint-disable-next-line no-param-reassign

    detail.value = value;
    return detail;
  });
};

var globalHelpersObjectName = "lwChatEmbeddedSvcHelpers";
var globalHelpers = {
  config: {
    getConfig: getConfig,
    getAllConfig: getAllConfig,
  },
  extraDetails: {
    getExtraDetail: getExtraDetail,
    updateExtraDetail: updateExtraDetail,
  },
  // This now uses our analytics.js to implement analytics more
  // generically, but we're preserving the googleAnalytics name
  // for compatibility in existing apps. Its API is the same.
  googleAnalytics: {
    sendEvent: sendEvent$1,
  },
};
window[globalHelpersObjectName] = globalHelpers;

var handlePrechatSurveySubmitted = function handlePrechatSurveySubmitted() {
  var prechatFormData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  if (prechatFormData.length) {
    emitter.emit("LWPrechatSurveySubmitted", prechatFormData);
  }

  var buttonDetail = prechatFormData.find(function (detail) {
    return detail.label === "Route To";
  });

  if (buttonDetail && buttonDetail.value) {
    return buttonDetail.value;
  } // If no "Route To" detail was submitted, we return undefined
  // so the chat will be routed to the default "All Chat" button.

  return undefined;
};

var doInitEmbeddedSvc = function doInitEmbeddedSvc(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    embeddedSvc = _ref2[0],
    initialExtraDetails = _ref2[1];

  var config = getAllConfig();
  /* eslint-disable no-param-reassign */

  embeddedSvc.settings.directToButtonRouting = handlePrechatSurveySubmitted;
  embeddedSvc.settings.extraPrechatFormDetails = initialExtraDetails;
  embeddedSvc.settings.displayHelpButton = config.displayHelpButton;
  embeddedSvc.settings.storageDomain = config.storageDomain;
  embeddedSvc.settings.enabledFeatures = ["LiveAgent"];
  embeddedSvc.settings.entryFeature = "LiveAgent";
  /* eslint-enable no-param-reassign */

  var afterInitPromise = new Promise(function (resolve) {
    return emitter.once("afterInit", resolve);
  });
  var baseCoreURL = config.baseCoreURL,
    communityEndpointURL = config.communityEndpointURL,
    gslbBaseURL = config.gslbBaseURL,
    orgId = config.orgId,
    eswConfigDevName = config.eswConfigDevName,
    settings = config.settings;
  embeddedSvc.init(
    baseCoreURL,
    communityEndpointURL,
    gslbBaseURL,
    orgId,
    eswConfigDevName,
    settings
  );
  return afterInitPromise;
};

var initPromise = null;

var init$2 = function init$2(config) {
  if (initPromise) return initPromise;
  if (config) mergeConfig(config);
  init();
  loadEmbeddedSvc();
  init$1();
  initPromise = Promise.all([
    getEmbeddedSvc(),
    getInitialExtraDetails$8(),
    watchEmbeddedServiceEvents(),
  ]).then(doInitEmbeddedSvc);
  return initPromise;
};

var awaitStartChatReady = function awaitStartChatReady() {
  // The ESW script looks for the presence of an .embeddedServiceSidebar
  // element to determine whether component initialization has already
  // occurred or is in progress. If found, it short-circuits the button
  // click handler, and the "ready" event is never emitted.
  //
  // We're relying on an undocumented internal implementation detail of
  // the ESW script here. This may break without notice, but there seems
  // to be no better way to ensure the correct behavior.
  if (document.getElementsByClassName("embeddedServiceSidebar").length) {
    return Promise.resolve();
  }

  var chatStartTimeout = getConfig("chatStartTimeout");
  var resolver;
  var readyPromise = new Promise(function (resolve, reject) {
    resolver = resolve;
    emitter.once("ready", resolver);
    setTimeout(reject, chatStartTimeout);
  });
  return readyPromise
    .finally(function () {
      return emitter.off("ready", resolver);
    })
    .catch(function () {
      emitter.emit("LWButtonClickTimeout");
      throw new Error("Ready timed out");
    });
};

var updateExtraDetails = function updateExtraDetails() {
  var extraDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Promise.all(
    Object.entries(extraDetails).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        label = _ref4[0],
        value = _ref4[1];

      return updateExtraDetail(label, value);
    })
  );
};

var startChat = function startChat() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    extraDetails = _ref5.extraDetails;

  if (!initPromise) throw new Error("Chat has not yet been initialized");
  return initPromise
    .then(function () {
      return updateExtraDetails(extraDetails);
    })
    .then(getEmbeddedSvc)
    .then(function (embeddedSvc) {
      return Promise.all([awaitStartChatReady(), embeddedSvc.onHelpButtonClick()]);
    })
    .then(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 1),
        result = _ref7[0];

      return result;
    });
};

export { emitter, init$2 as init, startChat };
//# sourceMappingURL=lw-chat.esm.js.map
